import { NextSeo } from 'next-seo';
import CallToActions from '@apps/components/ico-landing/CallToActions';
import React from 'react';
import FeaturesCard from '@apps/components/crypto/features-card';
import Features from '@apps/components/cryto-trading/Features';
import CardDrawer from '@apps/components/card-drawer/card-drawer';
import Hero_10 from '@apps/components/hero/hero_10';
import Services from '@apps/components/services/services';
import DescripCard from '@apps/components/descrip-card';

const NonFungibleTokens = () => {
  const metaTitle = 'Non-Fungible Tokens - Alchemis';
  const metaDesc = `Stepping into the digital future, your unique footprint matters. That's where we, Alchemis, come in with our expert Non-Fungible Token (NFT) Development services. We simplify the complex world of NFTs, empowering your business to make a significant digital leap.`;
  const metaImg = `/images/meta/services-nft.png`;
  const content = {
    title: 'Dive Into the Future: NFT Development',
    descriptions: `Stepping into the digital future, your unique footprint matters. That's where we, Alchemis, come in with our expert Non-Fungible Token (NFT) Development services. We simplify the complex world of NFTs, empowering your business to make a significant digital leap.`,
    headImage: '/images/alchemis-lab/nft.png',
    animationImage: '/images/alchemis-lab/nft-side.png',
    backgroundImage: '/images/alchemis-lab/background.png',
  };
  const features_data = {
    data: [
      {
        id: 1,
        icon: (
          <>
            <svg xmlns='http://www.w3.org/2000/svg' width='16' height='21' viewBox='0 0 16 21' fill='none'>
              <g clipPath='url(#clip0_384_45245)'>
                <path
                  d='M7.99416 0.5C3.69679 0.5 0.198839 3.79826 0.198839 7.8503H1.98434C1.98434 4.72805 4.67881 2.18739 7.99416 2.18739C11.3095 2.18739 13.9999 4.72805 13.9999 7.8503C13.9999 9.88971 12.8353 12.8972 12.0075 14.3856C11.2567 15.7324 10.3843 16.7962 9.4185 17.5461C8.33097 18.3879 7.1217 18.8164 5.82315 18.8164C3.59494 18.8141 1.78955 17.1103 1.78955 15.0093H0C0 18.0397 2.61332 20.5 5.82315 20.5C9.03299 20.5 11.6463 18.6557 13.5901 15.1662C15.2051 12.2735 15.7895 9.2048 15.7895 7.8503C15.7895 3.79826 12.2915 0.5 7.99416 0.5Z'
                  fill='#8358FF' />
                <path
                  d='M8.45737 14.0031C7.93795 14.4087 7.39013 14.6038 6.77738 14.6038V16.2874C7.80404 16.2874 8.74954 15.9583 9.5936 15.3079C10.255 14.7913 10.8434 14.0835 11.3345 13.1996C12.146 11.7456 12.5681 10.0238 12.5681 9.07103C12.5681 6.66812 10.4945 4.71289 7.95013 4.71289C5.39849 4.71519 3.33056 6.66506 3.32812 9.07103V9.91281H4.22087C4.55038 9.91281 4.81739 10.1642 4.8178 10.4749C4.8178 10.7856 4.55119 11.0374 4.22168 11.0377H4.22087V12.7213C5.53646 12.7248 6.60613 11.7223 6.60979 10.4818C6.61263 9.59332 6.05953 8.78674 5.19884 8.42439C5.57055 6.99144 7.10364 6.11446 8.62334 6.46495C9.89551 6.75842 10.7887 7.83629 10.7826 9.07103C10.7826 9.5608 10.531 11.0224 9.75186 12.419C9.37041 13.1001 8.93621 13.6358 8.45737 14.0031Z'
                  fill='#8358FF' />
              </g>
              <defs>
                <clipPath id='clip0_384_45245'>
                  <rect width='15.7895' height='20' fill='white' transform='translate(0 0.5)' />
                </clipPath>
              </defs>
            </svg>
          </>
        ),
        title: 'Understanding You',
        text: `We learn about your business and your vision for your NFTs.`
      },
      {
        id: 2,
        icon: (
          <>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <g clipPath="url(#clip0_625_43664)">
                <path d="M5 19.0001H6.414L15.728 9.68608L14.314 8.27208L5 17.5861V19.0001ZM21 21.0001H3V16.7571L16.435 3.32208C16.6225 3.13461 16.8768 3.0293 17.142 3.0293C17.4072 3.0293 17.6615 3.13461 17.849 3.32208L20.678 6.15108C20.8655 6.33861 20.9708 6.59292 20.9708 6.85808C20.9708 7.12325 20.8655 7.37756 20.678 7.56508L9.243 19.0001H21V21.0001ZM15.728 6.85808L17.142 8.27208L18.556 6.85808L17.142 5.44408L15.728 6.85808Z" fill="#8358FF"/>
              </g>
              <defs>
                <clipPath id="clip0_625_43664">
                  <rect width="24" height="24" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </>
        ),
        title: 'Design & Development',
        text: `Our team brings your vision to life with custom NFT design.`
      },
      {
        id: 3,
        icon: (
          <>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_625_43589)">
                <path d="M20.0565 22H3.94354C2.87182 22 2 21.1282 2 20.0565V3.94354C2 2.87182 2.87182 2 3.94354 2H20.0588C21.1305 2 22.0023 2.87182 22.0023 3.94354V20.0627C21.9979 21.131 21.1249 22.0002 20.0565 22.0002V22ZM3.94354 3.85099C3.89519 3.85099 3.85099 3.89519 3.85099 3.94354V20.0565C3.85099 20.1048 3.89519 20.149 3.94354 20.149H20.0565C20.1055 20.149 20.1506 20.1048 20.1513 20.0558V3.94354C20.1513 3.89519 20.1071 3.85099 20.0588 3.85099H3.94354Z" fill="#8358FF"/>
                <path d="M21.0732 5.39062H2.92188V7.24162H21.0732V5.39062Z" fill="#8358FF"/>
              </g>
              <g clipPath="url(#clip1_625_43589)">
                <path d="M15 12H16C16.1326 12 16.2598 12.0527 16.3536 12.1464C16.4473 12.2402 16.5 12.3674 16.5 12.5V18.5C16.5 18.6326 16.4473 18.7598 16.3536 18.8536C16.2598 18.9473 16.1326 19 16 19H8C7.86739 19 7.74021 18.9473 7.64645 18.8536C7.55268 18.7598 7.5 18.6326 7.5 18.5V12.5C7.5 12.3674 7.55268 12.2402 7.64645 12.1464C7.74021 12.0527 7.86739 12 8 12H9V11.5C9 10.7044 9.31607 9.94129 9.87868 9.37868C10.4413 8.81607 11.2044 8.5 12 8.5C12.7956 8.5 13.5587 8.81607 14.1213 9.37868C14.6839 9.94129 15 10.7044 15 11.5V12ZM11.5 15.866V17H12.5V15.866C12.6906 15.7559 12.8396 15.586 12.9239 15.3827C13.0081 15.1793 13.0229 14.9538 12.9659 14.7412C12.909 14.5285 12.7834 14.3406 12.6088 14.2066C12.4341 14.0726 12.2201 14 12 14C11.7799 14 11.5659 14.0726 11.3912 14.2066C11.2166 14.3406 11.091 14.5285 11.0341 14.7412C10.9771 14.9538 10.9919 15.1793 11.0761 15.3827C11.1604 15.586 11.3094 15.7559 11.5 15.866ZM14 12V11.5C14 10.9696 13.7893 10.4609 13.4142 10.0858C13.0391 9.71071 12.5304 9.5 12 9.5C11.4696 9.5 10.9609 9.71071 10.5858 10.0858C10.2107 10.4609 10 10.9696 10 11.5V12H14Z" fill="#8358FF"/>
              </g>
              <defs>
                <clipPath id="clip0_625_43589">
                  <rect width="20.0023" height="20" fill="white" transform="translate(2 2)"/>
                </clipPath>
                <clipPath id="clip1_625_43589">
                  <rect width="12" height="12" fill="white" transform="translate(6 8)"/>
                </clipPath>
              </defs>
            </svg>
          </>
        ),
        title: 'Smart Contract Creation',
        text: `We secure your NFT on the blockchain.`
      },
      {
        id: 4,
        icon: (
          <>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M14 19.9995V21.9995H2V19.9995H14ZM14.586 0.685547L22.364 8.46355L20.95 9.87955L19.89 9.52555L17.413 11.9995L23.07 17.6565L21.656 19.0705L16 13.4135L13.596 15.8175L13.879 16.9495L12.464 18.3635L4.686 10.5855L6.101 9.17155L7.231 9.45355L13.525 3.16055L13.172 2.10055L14.586 0.685547ZM15.293 4.22155L8.222 11.2915L11.757 14.8275L18.828 7.75755L15.293 4.22155Z" fill="#8358FF"/>
            </svg>
          </>
        ),
        title: 'Regulatory Compliance',
        text: `We help ensure your NFT is legally compliant.`
      },
      {
        id: 5,
        icon: (
          <>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M10 23.9482C4.477 23.9482 0 19.4712 0 13.9482C0 8.42524 4.477 3.94824 10 3.94824C15.523 3.94824 20 8.42524 20 13.9482C20 19.4712 15.523 23.9482 10 23.9482ZM10 21.9482C12.1217 21.9482 14.1566 21.1054 15.6569 19.6051C17.1571 18.1048 18 16.07 18 13.9482C18 11.8265 17.1571 9.79168 15.6569 8.29139C14.1566 6.7911 12.1217 5.94824 10 5.94824C7.87827 5.94824 5.84344 6.7911 4.34315 8.29139C2.84285 9.79168 2 11.8265 2 13.9482C2 16.07 2.84285 18.1048 4.34315 19.6051C5.84344 21.1054 7.87827 21.9482 10 21.9482ZM6.5 15.9482H12C12.1326 15.9482 12.2598 15.8956 12.3536 15.8018C12.4473 15.708 12.5 15.5808 12.5 15.4482C12.5 15.3156 12.4473 15.1885 12.3536 15.0947C12.2598 15.0009 12.1326 14.9482 12 14.9482H8C7.33696 14.9482 6.70107 14.6848 6.23223 14.216C5.76339 13.7472 5.5 13.1113 5.5 12.4482C5.5 11.7852 5.76339 11.1493 6.23223 10.6805C6.70107 10.2116 7.33696 9.94824 8 9.94824H9V7.94824H11V9.94824H13.5V11.9482H8C7.86739 11.9482 7.74021 12.0009 7.64645 12.0947C7.55268 12.1885 7.5 12.3156 7.5 12.4482C7.5 12.5808 7.55268 12.708 7.64645 12.8018C7.74021 12.8956 7.86739 12.9482 8 12.9482H12C12.663 12.9482 13.2989 13.2116 13.7678 13.6805C14.2366 14.1493 14.5 14.7852 14.5 15.4482C14.5 16.1113 14.2366 16.7472 13.7678 17.216C13.2989 17.6848 12.663 17.9482 12 17.9482H11V19.9482H9V17.9482H6.5V15.9482Z" fill="#8358FF"/>
              <path d="M18.6452 1.57097L19.2353 1.71429V2.4L18.6452 2.54331C18.397 2.60361 18.1703 2.72829 17.9894 2.90402C17.8085 3.07975 17.6802 3.29993 17.6181 3.54103L17.4706 4.11429H16.7647L16.6172 3.54103C16.5551 3.29993 16.4268 3.07975 16.2459 2.90402C16.065 2.72829 15.8383 2.60361 15.5901 2.54331L15 2.4V1.71429L15.5901 1.57097C15.8382 1.51057 16.0647 1.38584 16.2455 1.21012C16.4262 1.03439 16.5545 0.814269 16.6165 0.573257L16.7647 0H17.4706L17.6181 0.573257C17.6802 0.814354 17.8085 1.03453 17.9894 1.21027C18.1703 1.386 18.397 1.51067 18.6452 1.57097ZM22.1746 4.99954L22.7647 5.14286V5.82857L22.1746 5.97189C21.9264 6.03218 21.6997 6.15686 21.5188 6.33259C21.3379 6.50832 21.2096 6.7285 21.1475 6.9696L21 7.54286H20.2941L20.1466 6.9696C20.0845 6.7285 19.9562 6.50832 19.7753 6.33259C19.5944 6.15686 19.3677 6.03218 19.1195 5.97189L18.5294 5.82857V5.14286L19.1195 4.99954C19.3677 4.93925 19.5944 4.81457 19.7753 4.63884C19.9562 4.46311 20.0845 4.24293 20.1466 4.00183L20.2941 3.42857H21L21.1475 4.00183C21.2096 4.24293 21.3379 4.46311 21.5188 4.63884C21.6997 4.81457 21.9264 4.93925 22.1746 4.99954Z" fill="#8358FF"/>
            </svg>
          </>
        ),
        title: 'Minting',
        text: `We bring your NFT to life on the blockchain.`
      },
      {
        id: 6,
        icon: (
          <>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <g clipPath="url(#clip0_625_43712)">
                <path d="M4.1556 2.91961C6.33307 1.0328 9.11878 -0.00400783 12 1.16432e-05C18.6276 1.16432e-05 24 5.37241 24 12C24 14.5632 23.196 16.9392 21.828 18.888L18 12H21.6C21.6002 10.118 21.0471 8.27737 20.0096 6.70711C18.9721 5.13686 17.4959 3.9062 15.7646 3.16816C14.0333 2.43012 12.1233 2.21725 10.2719 2.55603C8.42064 2.89481 6.70975 3.77029 5.352 5.07361L4.1556 2.91961ZM19.8444 21.0804C17.6669 22.9672 14.8812 24.004 12 24C5.3724 24 0 18.6276 0 12C0 9.4368 0.804 7.0608 2.172 5.11201L6 12H2.4C2.39985 13.882 2.9529 15.7226 3.9904 17.2929C5.0279 18.8631 6.50408 20.0938 8.23538 20.8318C9.96669 21.5699 11.8767 21.7827 13.7281 21.444C15.5794 21.1052 17.2903 20.2297 18.648 18.9264L19.8444 21.0804Z" fill="#7444FF"/>
                <path d="M7.19817 5.71487C7.64748 5.55458 8.13307 5.52512 8.59846 5.62991C9.06386 5.73471 9.48996 5.96945 9.82721 6.30685C10.1645 6.64425 10.399 7.07045 10.5036 7.53589C10.6082 8.00134 10.5785 8.48691 10.418 8.93615L18.2264 16.7446L16.6986 18.2717L8.89017 10.464C8.44085 10.6243 7.95527 10.6537 7.48987 10.549C7.02447 10.4442 6.59838 10.2094 6.26113 9.87201C5.92388 9.53461 5.68933 9.10841 5.58474 8.64297C5.48016 8.17753 5.50984 7.69195 5.67033 7.24271L7.28025 8.85335C7.37987 8.9565 7.49905 9.03878 7.63081 9.09538C7.76258 9.15198 7.90429 9.18178 8.04769 9.18302C8.1911 9.18427 8.33331 9.15694 8.46604 9.10264C8.59877 9.04834 8.71935 8.96814 8.82075 8.86674C8.92216 8.76533 9.00235 8.64475 9.05666 8.51202C9.11096 8.37929 9.13828 8.23708 9.13704 8.09368C9.13579 7.95028 9.106 7.80856 9.0494 7.67679C8.9928 7.54503 8.91052 7.42586 8.80737 7.32623L7.19745 5.71415L7.19817 5.71487ZM14.6624 7.07135L16.9534 5.79839L17.9715 6.81647L16.6986 9.10751L15.4256 9.36239L13.8992 10.8895L12.8804 9.87143L14.4075 8.34431L14.6624 7.07135ZM9.57129 12.6715L11.0984 14.1994L7.53441 17.7634C7.33788 17.958 7.07412 18.0699 6.79755 18.0758C6.52097 18.0818 6.25265 17.9814 6.04793 17.7953C5.84322 17.6092 5.7177 17.3517 5.69728 17.0758C5.67686 16.7999 5.76308 16.5267 5.93817 16.3126L6.00801 16.2355L9.57201 12.6715H9.57129Z" fill="#7444FF"/>
              </g>
              <defs>
                <clipPath id="clip0_625_43712">
                  <rect width="24" height="24" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </>
        ),
        title: 'Post-sale Support',
        text: `We provide ongoing help to ensure your NFTs thrive.`
      }
    ]
  };
  const drawerItems = [
    {
      title: 'Art & Design',
      desc: 'NFTs offer artists new platforms to sell their digital artwork.',
      img: '/images/card-drawer/nft/item-01.svg',
      id: 1
    },
    {
      title: 'Music',
      desc: 'The music industry uses NFTs for rights management and fan engagement.',
      img: '/images/card-drawer/nft/item-02.svg',
      id: 2
    },
    {
      title: 'Real Estate',
      desc: 'NFTs are transforming real estate with virtual property trades.',
      img: '/images/card-drawer/nft/item-03.svg',
      id: 3
    },
    {
      title: 'Fashion',
      desc: 'Fashion brands are designing virtual NFT clothing and accessories.',
      img: '/images/card-drawer/nft/item-04.svg',
      id: 4
    },
    {
      title: 'Sport',
      desc: 'Sports entities are creating unique NFT collectibles.',
      img: '/images/card-drawer/nft/item-05.svg',
      id: 5
    },
    {
      title: 'Film',
      desc: 'The film industry is harnessing NFTs for digital merchandise and experiences.',
      img: '/images/card-drawer/nft/item-06.svg',
      id: 6
    }
  ];
  const servicesData = [
    {
      title: 'Customized NFT strategies ',
      desc: 'We provide customized NFT strategies to align with your goals.',
      id: '1',
      icon: '/images/services/nft/services-01.svg',
      itemClass: 'sm:col-span-6 lg:col-span-4'
    },
    {
      title: 'Experts advance',
      desc: 'Our experts oversee the design and development of your NFTs.',
      id: '2',
      icon: '/images/services/nft/services-02.svg',
      itemClass: 'sm:col-span-6 lg:col-span-4'
    },
    {
      title: 'Secure smart contracts',
      desc: 'We develop secure smart contracts for your NFTs.',
      id: '3',
      icon: '/images/services/nft/services-03.svg',
      itemClass: 'sm:col-span-6 lg:col-span-4'
    },
    {
      title: 'Guidance for Minting',
      desc: 'We guide you throughout the minting process.',
      id: '4',
      icon: '/images/services/nft/services-04.svg',
      itemClass: 'sm:col-span-6 lg:col-span-6'
    },
    {
      title: 'After-sales support',
      desc: 'Our after-sales support helps you maximize your NFT value.',
      id: '5',
      icon: '/images/services/nft/services-05.svg',
      itemClass: 'sm:col-span-6 lg:col-span-6'
    }
  ];
  const cardList = [
    {
      id: '1',
      icon: 'icon-1',
      desc: 'Create unique, secure digital assets with NFT Development.',
      itemClass: 'sm:col-span-6 lg:col-span-3'
    },
    {
      id: '2',
      icon: 'icon-2',
      desc: 'NFTs are not just collectibles; they\'re brand-enhancing tools.',
      itemClass: 'sm:col-span-6 lg:col-span-3'
    },
    {
      id: '3',
      icon: 'icon-3',
      desc: 'They offer a novel form of asset ownership applicable across industries.',
      itemClass: 'sm:col-span-6 lg:col-span-3'
    },
    {
      id: '4',
      icon: 'icon-4',
      desc: 'NFTs are secured by blockchain, ensuring the uniqueness of your digital assets.',
      itemClass: 'sm:col-span-6 lg:col-span-3'
    }
  ];

  return (
    <div>
      <NextSeo
        title={metaTitle}
        description={metaDesc}
        openGraph={{
          title: `${metaTitle}`,
          description: `${metaDesc}`,
          images: [
            {
              url: `${metaImg}`
            }
          ]
        }}
      />
      <Hero_10 content={content} />
      <DescripCard cardList={cardList} />
      <CardDrawer
        title={`Innovation Unleashed: <br/> The NFT Revolution`}
        subTitle={`The rise of NFTs is reshaping various industries. From art to music, real estate to sports,<br/> NFTs are paving the way for an exciting digital revolution.`}
        drawerItems={drawerItems} />
      <Services
        title={`Shape Your Digital Journey: <br/>Our NFT Development Service`}
        subTitle={`With our NFT Development services, we aim to reshape your digital presence, enriching your brand with creativity. Our comprehensive solution covers everything, from NFT concept to successful minting.`}
        servicesData={servicesData}
      />
      <Features title={`Your NFT Journey: <br/>The Alchemis Way`}
                subTitle={'At Alchemis, we meticulously craft your unique digital experiences. Here\'s our step-by-step approach to NFT development:'}
                featuresContent={features_data} />
      <FeaturesCard
        title={'Why Alchemis?'}
        subTitle={'Our technical prowess spans a multitude of blockchain platforms, allowing us to deliver solutions tailored to your business needs:'}
      />
      <CallToActions
        title={"Join us in revolutionizing the digital space with decentralized app development."}
        background={"/images/cta.png"}
        description={"Contact us today to see how our Web3 solution will help you realise your full business potential!"}
        btnText={"Start Now"}
        link={"/contact"}
      />
    </div>
  );
};

export default NonFungibleTokens;
